import { SkeletonLine } from '@crazyegginc/hatch';
import classNames from 'classnames';

export function SkeletonChart({ className }) {
  return (
    <div className={classNames('flex w-full h-full relative', className)} data-testid="loading-chart">
      <SkeletonLine className="w-full !absolute bottom-0 h-full !rounded" />
    </div>
  );
}
